import { Pipe, PipeTransform } from "@angular/core";
import { Customer } from "src/app/backend/models/customer/customer";
import { getCustomerNominative } from "src/app/support/customer";
import { Nullable } from "src/app/support/nullable";
import { Member } from "../backend/models/member/member";
import { Staff } from "../backend/models/staff/staff";

@Pipe({
  name: "customerNominative",
  standalone: false
})
export class CustomerNominativePipe implements PipeTransform {
  transform(
    customer: Nullable<{
      firstName?: string | undefined;
      lastName?: string | undefined;
    }>,
    inverted?: boolean,
    firstNameInitial?: boolean
  ): string {
    if (!customer) {
      return "";
    }

    return getCustomerNominative(customer, inverted, firstNameInitial);
  }
}
